import { lazy } from "react";
export var LazyMadeInUSA = /*#__PURE__*/ lazy(function() {
    return import(/* webpackChunkName: "retailer-made-in-usa-icon" */ "@faire/web--source/slate/icons/foundation/illustrations/MadeInUSA").then(function(module) {
        return {
            default: module.MadeInUSA
        };
    });
});
